<template>
  <div>
    <div class="col-12" v-for="(component, index) in components" :key="index">
      <component
        class="q-mt-sm"
        v-if="component"
        :is="component"
        @enviarValor="receberValor"
      />
    </div>
  </div>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import { useQuasar } from "quasar";
import formBuilder from "./formBuilder";

export default {
  emits: ["valido"],
  props: {
    schema: {
      type: Array,
    },
    valuesSchema: {
      type: Object,
    },
    verificar: {
      type: Number,
    },
  },
  setup(props, { emit }) {
    const quasar = useQuasar();

    const newSchema = ref(props.schema);
    const { components, generateComponents } = formBuilder();
    const values = ref({ ...props.valuesSchema });

    const receberValor = (object) => {
      values.value[object.name] = object.value;
    };

    const validarValues = () => {
      let valido = true;

      props.schema.forEach((element) => {
        if (element.props?.required) {
          if (
            values.value[element.name] == undefined ||
            values.value[element.name] == "" ||
            values.value[element.name] == null
          ) {
            valido = false;
          }
        }
      });
      if (!valido) {
        quasar.notify({
          message: `Preencha todos os campos`,
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      emit("valido", values);
    };

    watch(
      () => props.schema,
      () => {
        if (props.schema === undefined) {
          return;
        }
        newSchema.value = props.schema;
        generateComponents(props.schema, props.valuesSchema);
      }
    );

    watch(
      () => props.verificar,
      () => {
        validarValues();
      }
    );

    onMounted(() => {
      generateComponents(props.schema, props.valuesSchema);
    });

    return { components, generateComponents, newSchema, receberValor, values };
  },
};
</script>
